import { useRouter } from "next/router";
import React, { useEffect, useState, useMemo } from "react";

import { trpc } from "@calcom/trpc";
import { Select } from "@calcom/ui";
import { FiSearch } from "@calcom/ui/components/icon";

type Props = {
  officeId: number;
};

export default function Search({ officeId }: Props) {
  const router = useRouter();
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");

  const { data: patients, isFetching: isPatientSearching } =
    trpc.viewer.patients.searchByNameAndOffice.useQuery(
      {
        patientName: debouncedSearchQuery,
        officeId: officeId,
      },
      {
        enabled: debouncedSearchQuery.length >= 3,
        refetchInterval: false,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
      }
    );

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 800);
    return () => clearTimeout(timeoutId);
  }, [searchQuery]);

  useEffect(() => {
    setSearchQuery("");
    setDebouncedSearchQuery("");
  }, [officeId]);

  const options = useMemo(() => {
    return patients ?? [];
  }, [patients]);

  return (
    <div className="relative flex w-full items-center md:w-[400px]">
      <Select
        instanceId="patient-search"
        placeholder="Search by Account Name or Identifier"
        hasIcon={true}
        hideDropdown={false}
        options={options}
        isClearable={true}
        isLoading={isPatientSearching}
        onChange={(option) => {
          if (option) {
            router.push(`/patients/${option.value}`);
          }
        }}
        onInputChange={(value) => setSearchQuery(value)}
        styles={{
          menu: (defaultStyles) => ({
            ...defaultStyles,
            marginTop: "15px",
          }),
        }}
      />
      <FiSearch className="absolute left-2 h-4 w-4 cursor-pointer text-gray-500" />
    </div>
  );
}
